export default Object.freeze({
  MultiPersonRequests: 'multi_person_requests',
  Overlaps: 'overlaps',
  Handover: 'handover',
  TimeOffInLieu: 'toil',
  ExportToExcel: 'export_to_excel',
  Webhooks: 'webhooks',
})
